import svgIcons from "../assets/svg/svgIcons";
import { MODAL_TYPE } from "../constants/constants";
import { AdminFormFieldSubmit } from "./admin/formFields";

interface StatusModalProps {
  heading: string;
  fileName: string;
  type: MODAL_TYPE;
  subHeading?: string;
  onHide: () => void;
  containerStyle?: string;
}

export const BulkStatusModal = (props: StatusModalProps) => {
  return (
    <div className={`${props.type === 'upload' ? "fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay" : "max-w-[480px]"}`}>
      <div className="fixed max-w-[480px] bottom-0 right-10 z-overlay">
        <div className={`relative my-6 mx-auto z-modal`}>
          <div className="p-8 bg-white rounded-3xl shadow-2xl">
            <div className="flex flex-row justify-between items-center mb-2">
              <label className={`text-lg mr-16 font-bold leading-6 ${props.type === "success"
                ? "text-green-600" : props.type === "error" ? "text-red-600" : "text-black"}`}>
                {props.heading}
              </label>
              <img src={props.type === "error" ? svgIcons.Error : props.type === 'success' ? svgIcons.Success : svgIcons.Loading}
                alt="info"
                className={`size-6 ${(props.type !== "success" && props.type !== 'error') && "animate-spin"}`} />
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-heading-gray888">{props.fileName}</label>
              {
                props.subHeading && <label className="text-heading-gray888 line-clamp-3">{props.subHeading}</label>
              }
               <AdminFormFieldSubmit
                type="button"
                variant={props.type ==='processing' || props.type==='longProcess'|| props.type==='upload' ? "danger-transparent" : "primary-like"}
                onClick={props.onHide}
                label={props.type === 'processing' || props.type==='longProcess' || props.type==='upload' ? "Cancel" : 'Close'}
              />
              {/* <button type="button" onClick={props.onHide}>
                <label className={`text-sm font-bold ${props.type === "upload" ? "text-red-600" : "text-accent-blue-dark"}`}>
                  {props.type === 'upload' ? "Cancel" : "Close"}
                </label>
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}